import React from "react";
import PropTypes, { object, string } from "prop-types";
import style from "../StopInfoTableSquare.module.css";
import "../StopInfoTableSquare.module.css";

const LayoutCuatroSquare = ({ rows }) => {
  return (
    <table>
      <tbody className={style.tbodyLayoutCuatro}>
        {rows?.map((row, index) => (
          <tr key={index} className={style.trLayoutCuatro}>
            {Object.keys(row)
              .filter((key) => !key.startsWith("_"))
              ?.map((cell, index) => (
              <td className={style.tdLayoutCuatro} key={`col-${cell}-${index}`}>
                {row[cell]?.length > 3 ? (
                  <div className={style.marqueeContainer}>
                    <div
                      className={
                        row._isRealTime === false
                          ? style.marqueeTrackSlow
                          : style.marqueeTrack
                      }
                    >
                      <span className={style.marqueeItem}>{row[cell]}</span>
                      <span className={style.marqueeItem}>{row[cell]}</span>
                    </div>
                  </div>
                ) : (
                  <div>
                    <p>{row[cell]}</p>
                  </div>
                )}
              </td>
            ))}
          </tr>
        ))}
      </tbody>
    </table>
  );
};

LayoutCuatroSquare.propTypes = {
  columns: PropTypes.arrayOf(string),
  rows: PropTypes.arrayOf(object),
};

LayoutCuatroSquare.defaultProps = {
  columns: [],
  rows: [],
};

export default LayoutCuatroSquare;
